import React from 'react';
import { Alert, Paper, Typography, Grid } from '@mui/material';

const hasTransferDetails = (config) =>
  !!(config?.accountNumber || config?.iban || config?.recipientName);

const BankTransferDetails = ({
  config,
  confirmationNumber,
  amountDue,
  dueDate,
  embedded = false,
}) => {
  if (!hasTransferDetails(config)) {
    return (
      <Alert severity="info" sx={{ mb: embedded ? 0 : 3 }}>
        Skontaktuj się z obiektem w celu uzyskania danych do przelewu.
      </Alert>
    );
  }

  const content = (
    <>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        {confirmationNumber != null
          ? `Dane do przelewu (rezerwacja nr ${confirmationNumber})`
          : 'Dane do przelewu'}
      </Typography>
      {!embedded && (amountDue != null || dueDate) && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {amountDue != null && <>Kwota: <strong>{amountDue}</strong></>}
          {amountDue != null && dueDate && ' • '}
          {dueDate && <>Termin: <strong>{dueDate}</strong></>}
        </Typography>
      )}
      {!embedded && confirmationNumber != null && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          Tytuł przelewu: <strong>Rezerwacja {confirmationNumber}</strong>
        </Typography>
      )}
      <Grid container spacing={1.5}>
        {config.recipientName && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">Odbiorca</Typography>
            <Typography variant="body1" fontWeight={500}>{config.recipientName}</Typography>
          </Grid>
        )}
        {config.address && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">Adres</Typography>
            <Typography variant="body1" fontWeight={500}>{config.address}</Typography>
          </Grid>
        )}
        {config.accountNumber && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">Numer konta</Typography>
            <Typography variant="body1" fontWeight={500} sx={{ fontFamily: 'monospace' }}>
              {config.accountNumber}
            </Typography>
          </Grid>
        )}
        {config.iban && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">IBAN</Typography>
            <Typography variant="body1" fontWeight={500} sx={{ fontFamily: 'monospace' }}>
              {config.iban}
            </Typography>
          </Grid>
        )}
        {config.swift && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">SWIFT / BIC</Typography>
            <Typography variant="body1" fontWeight={500} sx={{ fontFamily: 'monospace' }}>
              {config.swift}
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: 2 }}>
      {content}
    </Paper>
  );
};

export default BankTransferDetails;
